<template>
  <svg
    v-if="flag"
    class="lp-flag"
    viewBox="0 0 16 11"
    role="img"
    :aria-label="props.label"
  >
    <!-- Inline rather than the 🇱🇹 / 🇱🇻 emoji, which draw nothing on Windows.
         Top and bottom bands carry the corner rounding; the middle one is a
         plain rect. Latvia's white band is narrower than the other two flags'
         middle bands, so each flag brings its own split. -->
    <path :d="topBand" :fill="flag.colors[0]" />
    <path :d="middleBand" :fill="flag.colors[1]" />
    <path :d="bottomBand" :fill="flag.colors[2]" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Flag {
  colors: [string, string, string];
  /** y where the middle band starts and ends, in the 0-11 viewBox. */
  split: [number, number];
}

const FLAGS: Record<string, Flag> = {
  LT: { colors: ["#FDB913", "#006A44", "#C1272D"], split: [3.667, 7.333] },
  LV: { colors: ["#9E3039", "#FFFFFF", "#9E3039"], split: [4.4, 6.6] },
  EE: { colors: ["#0072CE", "#000000", "#FFFFFF"], split: [3.667, 7.333] },
};

const props = defineProps<{
  country: string;
  label: string;
}>();

const flag = computed(() => FLAGS[props.country]);

const topBand = computed(
  () => `M2 0h12a2 2 0 0 1 2 2v${flag.value.split[0] - 2}H0V2a2 2 0 0 1 2-2z`,
);
const middleBand = computed(
  () => `M0 ${flag.value.split[0]}h16v${flag.value.split[1] - flag.value.split[0]}H0z`,
);
const bottomBand = computed(
  () =>
    `M0 ${flag.value.split[1]}h16V9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V${flag.value.split[1]}z`,
);
</script>
